import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import "bootstrap/dist/css/bootstrap.min.css";
import { DynamicComponents } from "components/DynamicComponents/DynamicComponents";
import { ServiceConfig } from "config/ServiceConfig";
import { setupMocks } from "mocks/init";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { App } from "./App";
import "./index.css";
import "./index.scss";
import "rsuite/dist/styles/rsuite-default.css";
// Must come after rsuite-default.css — overrides its CDN-hosted icon font
// with the v4 files the package ships (see the comment in the file).
import "./styles/rsuite-icon-font.css";
import { intercept } from "./services/util/HTTPInterceptor";
import { themeColor } from "./Theme";

//TODO <-- temporary fix for spring map view, delete this when task 49019 completes.
import React from "react";
window.React = React;
//-->

// console.init(new Integrations.ReactSentryLogger(ServiceConfig.spring_logger || ''));

intercept();
setupMocks();
DynamicComponents.RegisterDefaultComponents();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: 3600000,
      refetchOnWindowFocus: false,
    },
  },
});

ServiceConfig.initializePortalConfiguration().then(() => {
  themeColor();
  ReactDOM.render(
    // <React.StrictMode>
    <DndProvider backend={HTML5Backend}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </DndProvider>,
    // </React.StrictMode>
    document.getElementById("root")
  );
});

ModuleRegistry.registerModules([AllCommunityModule]);
